module.exports = "Farm Name,User Email,Status,Pigs Count,Estimated Weight,Address,City,Farm Type,Federal Premise ID,Zip Code,State\n"